<template>
  <div class="app-body">
    <el-form
        :inline="true"
        :model="queryForm"
        @keyup.enter.native="$refs.table.reload()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item prop="orderCode" label="订单编号：">
        <el-input v-model="queryForm.orderCode" size="mini" clearable type="text"
                  placeholder="请输入订单编号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="$refs.table.reload()" size="mini">查询</el-button>
        <el-button type="warning" @click="$refs.table.export()" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
    <SweetTable url="/trade/purchase/wraning" :query-form="queryForm" ref="table" :summaries-column="['totalCount','productCount']" :before-table-binding="beforeTableBinding">
      <el-table-column label="订单编号" min-width="120" prop="orderCode" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="订单品番" header-align="center">
        <el-table-column label="品番号" min-width="120" prop="product.code" header-align="center" align="center"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="SKU" width="80" prop="product.skuCode" header-align="center" align="center"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="品名" min-width="120" align="center" prop="product.name" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="中文名" width="80" align="center" prop="product.nameZh" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
            label="颜色"
            prop="product.color"
            header-align="center"
            align="center"
            width="100"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            label="规格"
            prop="product.size"
            header-align="center"
            align="center"
            width="100"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            label="返单号"
            prop="backCount"
            header-align="center"
            align="center"
            width="100"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
      </el-table-column>
      <el-table-column label="原料单耗" header-align="center">
        <el-table-column label="品名" min-width="120" align="center" prop="material.name" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
            label="颜色"
            prop="material.color"
            header-align="center"
            align="center"
            width="100"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            label="规格"
            prop="material.size"
            header-align="center"
            align="center"
            width="100"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            label="幅宽"
            prop="material.attr1"
            header-align="center"
            align="center"
            width="100"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            label="克重"
            prop="material.attr2"
            header-align="center"
            align="center"
            width="100"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
      </el-table-column>
      <el-table-column label="品番订购量" min-width="120" align="center" prop="productCount">
      </el-table-column>
      <el-table-column label="单耗数量" min-width="120" align="center" prop="bomCount">
      </el-table-column>
      <el-table-column label="总计" min-width="120" align="center" prop="totalCount">
      </el-table-column>
    </SweetTable>
  </div>
</template>

<script>
import BigNumber from 'bignumber.js'
export default {
  name: 'warning',
  data () {
    return {
      queryForm: { orderCode: undefined }
    }
  },
  activated () {
    this.$nextTick(() => {
      this.$refs.table.reload()
    })
  },
  methods:{
    beforeTableBinding(dataList){
      dataList.forEach(row=>{
        row.totalCount=new BigNumber(row.bomCount||0).multipliedBy(row.productCount||0).toFixed(3)
      })
    }
  }
}
</script>

<style scoped>

</style>
